import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppSettings } from '../app.settings';

@Injectable()
export class SettingsService {
    private _settings: AppSettings;
    constructor(private http: HttpClient) {
    }

    public Load(): Promise<AppSettings> {
        return new Promise((resolve) => {
            this.http.get('./appSettings.json').map(res => res)
            .subscribe((config: AppSettings) => {
                this.copyConfiguration(config, new AppSettings()).then((data: AppSettings) => {
                    this._settings = data;
                    resolve(this._settings);
                });
            }, (error: any) => {
                this._settings = new AppSettings();
                resolve(this._settings);
            });
        });
    }

    public Get() {
        return this._settings;
    }

    private copyConfiguration(source: Object, destination: Object): any {
        return new Promise(function(resolve) {
            Object.keys(source).forEach(function(key) {
                destination[ key ] = source[ key ];
                resolve(destination);
            });
        });
    }
}

export function settingsServiceFactory(settings: SettingsService) {
    return () => settings.Load();
}



// WEBPACK FOOTER //
// ./src/app/settings/services/settings.service.ts